import { createContext, useContext } from "react";

export const ScrollContext = createContext({ scrollTo: () => {} });

export const useSmoothScroll = () => useContext(ScrollContext);
